<template>
  <div id="serviceDesktop">

    <div class="service-information">
      <div class="slider-container">
        <Slider ref="slider" class="slider">
          <div class="slide" :style="{'background-image': 'url(' + image + ')'}" v-for="image of images"></div>
        </Slider>
        <div class="dots" v-if="$refs.slider && $refs.slider.getPageCount() > 1">
          <div class="dot" v-for="n in $refs.slider.getPageCount()" :class="{active: $refs.slider.getPage === n - 1}"></div>
        </div>
      </div>

      <div class="service-description">
        <div class="service-name" v-if="service">{{$to(service.name)}}</div>
        <div class="section" v-if="service && $to(service.description) && $to(service.description).length > 0">
          <div class="leftIcon">
            <svgicon src="svg/info.svg" :width=20 :height=20></svgicon>
          </div>
          <div class="content">{{ $to(service.description) }}</div>
        </div>
        <div class="parent-section">
          <div class="section" v-if="service && service.link">
            <div class="leftIcon">
              <svgicon src="svg/site.svg" :width=20 :height=20></svgicon>
            </div>
            <div class="content">
              <ExternalLink :url="service.link" target="_blank">{{ service.link }}</ExternalLink>
            </div>
          </div>
          <div class="section" v-if="service && service.email">
            <div class="leftIcon">
              <svgicon src="svg/mail.svg" :width=20 :height=20></svgicon>
            </div>
            <div class="content">
              <ExternalLink :url="'mailto:' + service.email" target="_system">{{ service.email }}</ExternalLink>
            </div>
          </div>
          <div class="section" v-if="service && service.phoneNumber">
            <div class="leftIcon">
              <svgicon src="svg/phone.svg" :width=20 :height=20></svgicon>
            </div>
            <div class="content">
              <ExternalLink :url="'tel:' + service.phoneNumber" target="_system">{{ service.phoneNumber }}</ExternalLink>
            </div>
          </div>
        </div>
        <div class="section" v-if="service && service.externalLinks && service.externalLinks.length > 0">
          <div class="leftIcon">
            <svgicon src="svg/internet.svg" :width=20 :height=20></svgicon>
          </div>
          <ul class="content" v-if="service.externalLinks.length > 1">
            <li v-for="(link, linkIndex) of service.externalLinks" :key="'link' + linkIndex" v-if="link.url">
              <ExternalLink target="_blank" :url="link.url">{{$to(link.name) || link.url}}</ExternalLink>
            </li>
          </ul>
          <div class="content" v-if="service.externalLinks.length === 1">
            <ExternalLink target="_blank" :url="service.externalLinks[0].url">{{$to(service.externalLinks[0].name) || service.externalLinks[0].url}}</ExternalLink>
          </div>
        </div>

        <div class="grow"></div>

        <div class="contact" v-if="service && user.token">
          <ExternalLink class="btn btn-primary" v-if="service.phoneNumber" :url="'tel:' + service.phoneNumber" target="_system">
            <div class="icon">
              <img src="@/assets/img/icons/phone.png">
            </div>
            <div class="name">{{ $t("service.call") }}</div>
          </ExternalLink>
          <ExternalLink class="btn btn-primary" v-if="service.email" :url="'mailto:' + service.email" target="_system">
            <div class="icon">
              <img src="@/assets/img/icons/mail.png">
            </div>
            <div class="name">{{ $t("service.contact") }}</div>
          </ExternalLink>
          <router-link :to="'/new-booking?service=' + service.id" class="btn btn-primary" v-if="schedules.getForService(service.id)">
            <div class="icon">
              <img src="@/assets/img/icons/booking.png">
            </div>
            <div class="name">{{$t('service.book')}}</div>
          </router-link>
        </div>
      </div>
    </div>

    <Panel :title="$t('service.documents')" v-if="service && service.documents && service.documents.length > 0">
      <div class="documents">
        <div class="document" v-for="(document, documentIndex) of service.documents" :key="'document-' + documentIndex">
          <div class="icon">
            <svgicon src="svg/paperclip.svg" :height="20" :width="20"></svgicon>
          </div>
          <div class="name">{{document.name}}</div>
          <ExternalLink class="btn btn-neutral" :url="(CONFIG.urlFiles + document.url)" target="_blank">
            <svgicon src="svg/download.svg" :height="16" :width="16" ></svgicon>
          </ExternalLink>
        </div>
      </div>
    </Panel>

    <Panel :title="$t('service.open_hours')" class="service-hours" v-if="hasOpeningHours">
      <div class="split">

        <div class="left">
          <div class="day" v-for="(day,index) of openHours.slice(0,4)" :key="index" :class="{today: day.day === today}">
            <div class="name">{{$t("weekDays." + day.day)}}</div>
            <div class="hours" v-if="day.hours.length > 0">
              <div class="range" v-for="range of day.hours">{{range.from}} {{$t('to')}} {{range.to}}</div>
            </div>
            <div class="closed" v-if="day.hours.length === 0">
              {{$t('service.close')}}
            </div>
          </div>
        </div>
        <div class="right">
          <div class="day" v-for="(day,index) of openHours.slice(4,7)" :key="index" :class="{today: day.day === today}">
            <div class="name">{{$t("weekDays." + day.day)}}</div>
            <div class="hours" v-if="day.hours.length > 0">
              <div class="range" v-for="range of day.hours">{{range.from}} {{$t('to')}} {{range.to}}</div>
            </div>
            <div class="closed" v-if="day.hours.length === 0">
              {{$t('service.close')}}
            </div>
          </div>
        </div>

      </div>
    </Panel>

    <div class="actions">
      <router-link to="/services" class="btn btn-primary">{{$t('navigation.back')}}</router-link>
    </div>

  </div>
</template>

<script>

  import Slider from "../Slider.vue";
  import Panel from "../Panel.vue";
  import ExternalLink from "../ExternalLink.vue";
  import moment from "moment";

  export default {
    name: "ServiceDesktop",

    components: { Slider, Panel, ExternalLink },

    data() {
      return {
        CONFIG
      }
    },

    props: {
      user: Object,
      service: Object,
      schedules: Object,
      images: Array,
      days: Array,
      openHours: Array,
      hasOpeningHours: Boolean
    },

    computed: {
      today() {
        return this.days[moment().format('e')];
      }
    }
  }
</script>

<style lang="scss" scoped>
  #serviceDesktop {
    padding: 60px;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

  .slider-container {
    min-height: 300px;
    flex-grow: 1;
    flex-basis: 0;
    position: relative;
  }

  .slider {
    height: 100%;
    background-color: white;
    .slide {
      background-size: cover;
      background-position: center;
    }
  }

  #serviceDesktop .section {
    margin: 0 30px;
  }

  .grow {
    flex-grow: 1;
  }

  .service-name {
    padding: 30px 30px 0 30px;
    font-weight: bold;
    font-size: 20px;
  }

  .dots {
    position: absolute;
    top: 170px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    .dot {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: white;
      border: 2px solid white;
      &.active {
        background-color: black;
      }
      &:not(:last-of-type) {
        margin-right: 10px;
      }
    }
  }

  .service-information {
    margin-bottom: 30px;
    display: flex;
  }

  .service-description {
    flex-grow: 1;
    flex-basis: 0;
    background-color: white;
    display: flex;
    flex-direction: column;
  }

  .actions {
    display: flex;
    justify-content: flex-start;
  }

  .contact {
    display: flex;
    padding: 30px;

    .btn {
      width: 150px;
      margin-right: 15px;
      padding: 25px;
      .icon {
        margin-right: 20px;
      }
    }
  }

  .service-hours .split {
    display: flex;

    .left, .right {
      flex-grow: 1;
      flex-basis: 0;
    }

    .left {
      margin-right: 30px;
    }
  }

  .content {
    padding-top: 6px;
  }

  .day {
    background-color: #f2f3f4;
    border-radius: 4px;
    margin-bottom: 15px;
    display: flex;
    justify-content: space-between;
    padding: 10px;

    &.today {
      font-weight: 600;
    }
  }
</style>
